export const BTS_THUMBNAIL = 'BTS_THUMBNAIL';
export const BTS_EXPANDED = 'BTS_EXPANDED';
export const BTS_TROUBLESHOOTING = 'BTS_TROUBLESHOOTING';
export const BTS_LIVE_AGENT_CHAT = 'BTS_LIVE_AGENT_CHAT';
